"use strict";var u;(function(o){o.halfAnHour="halfAnHour",o.oneHour="oneHour",o.twoHours="twoHours",o.fullNight="fullNight"})(u||(u={}));export{u as PriceType};
